import { useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import { isNonNullish } from "../../../abstract/controller/utils/systemUtils";
import useNodeTraversal from "../../../abstract/hook/useNodeTraversal";
import styles from "./ChildrenUndefined.module.scss";
import UndefinedPanel from "./UndefinedPanel";
import { getIsFolded } from "../../../abstract/redux/slice/metaSlice";

function ChildrenUndefined({ node, readOnly = false }) {
  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const _name = nodeUtils.getName(node);
  const _nodeTarget = useNodeTraversal(_id);

  const _isFolded = useSelector(getIsFolded(_uuid));
  const _defaultValue = nodeUtils.getValueDefault(node);

  if (_isFolded || isNonNullish(_defaultValue)) {
    return null;
  }

  const _hasParameters = nodeUtils.hasParameters(_nodeTarget);
  const _hasChoices = nodeUtils.hasChoices(_nodeTarget);

  if (!_name || _hasParameters || _hasChoices) {
    return null;
  }

  const _idTarget = nodeUtils.getIdTarget(node);
  const _parsedReadOnly = readOnly || _idTarget;

  return (
    <div className={`${styles["children"]} ${_parsedReadOnly ? styles["children--readOnly"] : ""}`}>
      {!_parsedReadOnly && (
        <div className={styles["children__panel"]}>
          <UndefinedPanel id={_id} />
        </div>
      )}
    </div>
  );
}

export default ChildrenUndefined;
